import clsx from 'clsx';
import React, { FC, memo } from 'react';
import styles from './icons.module.css';
import { MiniBasketIcon } from '../../components/menu-icons/mini-basket-icon/mini-basket-icon.component';
import { AvatarIcon } from '../../components/menu-icons/avatar-icon/avatar-icon.component';

type Props = {
    className?: string;
    isSearchPage?: boolean;
};

const Icons: FC<Props> = memo(({ className, isSearchPage }) => {
    return (
        <div className={clsx(styles.root, className, { [styles.searchPage]: isSearchPage })}>
            <AvatarIcon />
            <MiniBasketIcon />
        </div>
    );
});

Icons.displayName = 'Icons';
export default Icons;
